import {IOneTrustGeolocation} from 'coreClasses/geolocation/providers/OneTrustGeolocationProvider';

/**
 * Represents OneTrustApi
 */
class OneTrustApi {
	/**
	 * Returns customer geolocation
	 * @returns {IOneTrustGeolocation}
	 */
	public getGeolocation(): Promise<IOneTrustGeolocation> {
		return fetch('https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location', {
			method: 'GET',
			headers: {
				Accept: 'application/json',
			},
		}).then((response) => response.json());
	}
}

export default new OneTrustApi();
